import React from 'react';

class Background extends React.Component{
	constructor(props){
		super(props);
		
		this.state = {
			frame:0
		}
		this.circleUid = 0;

		this.dots = [];
		for(let i = 0; i < 75; i++) this.addDot();
		this.lastUpdate = Date.now();
		setInterval(_=>{
			this.update();
		}, 1000/45)
	}

	update(){
		let now = Date.now();
		let timePassed = (now - this.lastUpdate)/1000;
		this.lastUpdate = now;

		for(let i = this.dots.length-1; i >= 0; i--){
			const dot = this.dots[i];
			if(dot.rendered) dot.opacity = 0.5;
			dot.angle += Math.random()*0.15-0.075;
			dot.cx += Math.cos(dot.angle) * timePassed*2
			dot.cy += Math.sin(dot.angle) * timePassed*2

			if(dot.cx < -dot.r || dot.cx > 100+dot.r
			|| dot.cy < -dot.r + (this.props.isMobile ? -50*this.props.ratio:0) || dot.cy > 100*this.props.ratio+dot.r){
				this.dots.splice(i, 1);
				this.addDot();
			}
		}

		this.setState({frame: this.state.frame+1});
	}

	addDot(){
		this.dots.push(
			{
				opacity: 0,
				angle: Math.random() * Math.PI*2,
				cx: Math.random() * 100,
				cy: Math.random() *100*this.props.ratio + (this.props.isMobile ? -50*this.props.ratio:0),
				r:0.3*this.props.ratio * (Math.random()*0.5+1),
				fill:`hsl(${Math.random()*360}, 80%, 80%)`,
				key: this.circleUid++,
			}
		)
	}

	render(){
		return (
			<>
				{[...this.dots].map((e,i)=>{
					e.rendered = true;
					return (
					<circle
						cx={e.cx}
						cy={e.cy}
						r={e.r}
						fill={e.fill}
						opacity={e.opacity}
						key={e.key}/>
				)})}
			</>
		)
	}
}

export default Background;